import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScrollList from './ScrollList.js';
/*import AppNavBar from './AppNavBar.js';*/

export default class AppComp extends Component {

    constructor(props) {
        super(props);

        this.state = {
          viewport: {
              width: document.documentElement.clientWidth,
              height: document.documentElement.clientHeight
          },
            breakpoint:747
        };

        //binding
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {


      window.addEventListener("resize", this.handleResize, false);

      this.setState({
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        });


  }

  handleResize(e) {

    this.setState({
          viewport: {
              width: document.documentElement.clientWidth,
              height: document.documentElement.clientHeight,
              breakpoint:747,
          }
      });
  }

    render() {

      const {

          breakpoint,
          viewport,
      } = this.state;

      //var wW = viewport.width / 2;
      var wW1 = this.state.viewport.width > this.state.breakpoint ? viewport.width / 4 : viewport.width;
      var hH = this.state.viewport.width > this.state.breakpoint ? viewport.width/4 : viewport.width* 4;
      var cl = this.state.viewport.width > this.state.breakpoint ? 'scl_fourth' : 'scl_full';
        return (
          <div className="appOuter">

          <div className="scrollListOuter">
          <ScrollList className={cl} arr={window.wImages_2} wW= {wW1} title=" " initialScroll={hH}/>
          <ScrollList className={cl} arr={window.wImages_3} wW= {wW1} title=" " initialScroll={hH}/>
          <ScrollList className={cl} arr={window.wImages_4} wW= {wW1} title=" " initialScroll={hH}/>
          <ScrollList className={cl} arr={window.wImages_5} wW= {wW1} title=" " initialScroll={hH}/>
          </div>

        </div>
          );
    }
}



// WEBPACK FOOTER //
// ./src/js/components/AppComp.js